<template>
  <div class="height-100-p">
    <el-table
        :data="masterRatesManagement.list.map(item => ({ ...item, hasAllWarehouses: hasAllWarehouses(item.warehouseNames || []) }))"
        v-loading="masterRatesManagement.loadingSearch"
        id="masterRatesManagement-data-list"
        ref="dayOfServiceManagementTable"
        size="mini"
        tooltip-effect="dark"
        class="dark-blue-table"
        :empty-text="$t('common.notAbleToFindRecords')"
        @sort-change="handleSortChange"
        stripe
    >
      <el-table-column prop="chargeCode" :label="$t('masterRates.management.chargeCode')" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
          <el-tooltip class="item"
                          effect="dark"
                          :enterable="false"
                          :content="scope.row.chargeCodeName"
                          placement="top-start">
          <span>
            {{scope.row.chargeCodeName}}
          </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="warehouse" label="Warehouses" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
          <span>
            {{ warehousesLabel(scope.row.warehouseNames) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="Rate" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
          <span>
            {{scope.row.rate | rateFilter(scope.row.unitsOfMeasure === '%' ) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="effectiveDate" :label="$t('masterRates.management.effectiveDate')" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
          <span>
            {{scope.row.effectiveDate}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="expirationDate" :label="$t('masterRates.management.expirationDate')" :min-width="6" align="center" sortable="custom">
        <template slot-scope="scope">
          <span :class="{ 'expiredDate': isExpired(scope.row.expirationDate) }">
            {{scope.row.expirationDate}}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="action" :label="$t('masterRates.management.options')" :min-width="4" align="center">
        <template slot-scope="scope">
            <span id="day-of-service-list-actions">
              <detail-master-rate :masterRates="scope.row"/>
              <add-master-rate :masterRate="scope.row"/>
            </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-footer" v-show="masterRatesManagement.total > 0">
      <span class="el-pagination__total">
        <span class="el-pagination__title">{{ $t('masterRates.totalMasterRates') }}</span>
           {{ masterRatesManagement.total }}
      </span>
      <el-pagination
          @size-change="handleSearchChangeLimit"
          :page-sizes="sizes"
          :page-size="masterRatesManagement.actualFilters.rows"
          :current-page.sync="masterRatesManagement.actualFilters.page"
          @current-change="handleSearchChangePage"
          :total="masterRatesManagement.total"
          layout="sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import constants from '@/utils/constants';
import transformLabels from '@/plugins/unitDataTransformLabels';
import { MASTER_RATES_MANAGEMENT_SEARCH, MASTER_RATES_MANAGEMENT_DELETE } from '@/store/actions';
import { Message } from 'element-ui';
import DetailMasterRate from './components/detailMasterRate/DetailMasterRate';
import AddMasterRate from './components/addMasterRate/AddMasterRate';

export default {
  name: 'SearchSummaryList',
  mixins: [transformLabels],
  computed: {
    ...mapGetters(['masterRatesManagement'])
  },
  props: {
    warehouseList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    DetailMasterRate,
    AddMasterRate
  },
  data() {
    return {
      sizes: constants.TABLES.DEFAULT_LIMIT_SIZES,
    };
  },
  methods: {
    handleSearchChangePage(val) {
      this.$store.dispatch(MASTER_RATES_MANAGEMENT_SEARCH, { page: val });
    },
    handleSearchChangeLimit(val) {
      this.$store.dispatch(MASTER_RATES_MANAGEMENT_SEARCH, { rows: val, page: constants.TABLES.DEFAULT_PAGE });
    },
    handleSortChange({ prop, order }) {
      this.$store.dispatch(MASTER_RATES_MANAGEMENT_SEARCH, {
        orderField: prop,
        orderDirection: constants.TABLES.ORDER_DIRECTION[order]
      });
    },
    getDayLabel(daysArray) {
      if (!Array.isArray(daysArray)) return '';
      return daysArray
        .map(dayInt => {
          const dayObj = constants.DAY_OF_SERVICE.DAYS_OF_WEEK.find(d => d.numberValue === dayInt);
          return dayObj ? dayObj.label : '';
        })
        .filter(label => label) // elimina vacíos
        .join('; ');
    },
    isExpired(date) {
      const today = new Date();
      const expirationDate = new Date(date);
      return expirationDate < today;
    },
    formatMinimumValue(value) {
      if (value === null || value === undefined || value === '') return '-';
      return Number(value).toFixed(2);
    },
    isAllDays(daysArray) {
      if (!Array.isArray(daysArray)) return false;
      const allDays = [1, 2, 3, 4, 5, 6, 7];
      return allDays.every(day => daysArray.includes(day));
    },
    async handleDelete(row) {
      Message.closeAll();

      const confirm = await this.$confirm(
        this.$t('daysOfService.deleteDayOfServiceMessage'),
        { confirmButtonText: this.$t('common.delete'), dangerouslyUseHTMLString: true }
      ).catch(() => {
      });

      if (confirm) {
        const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
        try {
          const response = await this.$store.dispatch(MASTER_RATES_MANAGEMENT_DELETE, row.id);
          this.$message.success(response.message);
        } finally {
          loading.close();
          await this.$store.dispatch(MASTER_RATES_MANAGEMENT_SEARCH, {});
        }
      }
    },
    hasAllWarehouses(rowWarehouses) {
      return this.warehouseList.length > 0 && rowWarehouses.length === this.warehouseList.length;
    },
    warehousesLabel(rowWarehouses) {
      if (!rowWarehouses) return '';
      if (!Array.isArray(rowWarehouses)) return rowWarehouses;
      if (this.hasAllWarehouses(rowWarehouses)) {
        return this.$t('common.all');
      }
      return rowWarehouses.join(', ');
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
  .expiredDate {
    color:#ed1c25;
  }
</style>
